import { IgProductTagIcon } from '@buffer-mono/popcorn'

import type { Image } from '~publish/legacy/composer/composer/entities/factories'

import { getInstagramPreviewHeight } from '../../../Common/utils'

import styles from './ImagePreview.module.css'

import type { JSX } from 'react'

export const ImagePreview = ({
  image,
  stickerProducts,
}: {
  image: Image
  stickerProducts?: string
}): JSX.Element => {
  const { height, width } = image
  const previewHeight = getInstagramPreviewHeight({ height, width })

  return (
    <div
      className={styles.wrapper}
      data-testid="preview-images"
      style={{ height: `${previewHeight}px` }}
    >
      {stickerProducts && (
        <div className={styles.productsSticker}>
          <IgProductTagIcon color="inverted" />
        </div>
      )}
      <img
        className={styles.image}
        src={image.url}
        alt={image.altText || 'Post image'}
      />
    </div>
  )
}
